import {SharedAnimations} from 'src/app/shared/animations/shared-animations';
import {RequestService} from '../../../shared/services/request.service';
import {NotificationService} from '../../../shared/services/notification.service';
import {SessionStorageService} from '../../../shared/services/session-storage.service';
import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {ResolveEnd, ResolveStart, RouteConfigLoadEnd, RouteConfigLoadStart, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
    selector: 'app-signin',
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.scss'],
    animations: [SharedAnimations]
})
export class SigninComponent implements OnInit {
    loading: boolean;
    loadingText: string;
    signinForm: FormGroup;
    url = '/sessions/signin';

    constructor(private formBuilder: FormBuilder,
                private translate: TranslateService,
                private requestService: RequestService,
                private sessionStorageService: SessionStorageService,
                private notificationService: NotificationService,
                private router: Router) {
        this.translate.use('en');
        this.sessionStorageService.setLanguageSession('en');
    }

    ngOnInit() {
        this.checkUserSession();
        this.router.events.subscribe((event: any) => {
            if (event instanceof RouteConfigLoadStart || event instanceof ResolveStart) {
                this.loadingText = 'Loading Dashboard Module...';
                this.loading = true;
            }
            if (event instanceof RouteConfigLoadEnd || event instanceof ResolveEnd) {
                this.loading = false;
            }
        });

        this.signinForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });
    }

    signin(form: NgForm) {
        this.loading = true;
        this.loadingText = 'Signing in...';
        if (form.valid) {
            this.signinForm.patchValue({username: form.value.username.trim()});
            setTimeout(() => {
                this.requestService.postData('Auth/login', form.value, 'post').subscribe((receivedData: Object) => {
                        const data = receivedData['data'];
                        if (receivedData['status'] == true) {
                            if (receivedData['type'] != 'SUCCESS') {
                                this.translate.get([receivedData['type'], receivedData['message']]).subscribe((response: string) => {
                                    this.notificationService.basicNoty(receivedData['type'], response[receivedData['message']], response[receivedData['type']]);
                                });
                            } else {
                                this.setUserSession(data, data['token'])
                                    .then(() => {
                                        this.loading = false;
                                        receivedData['data']['menu_privilege'] = receivedData['data']['menu_privilege'].split(',').map(Number);
                                        if (receivedData['data']['id'] == 2) {
                                            receivedData['data']['menu_privilege'] = [...receivedData['data']['menu_privilege'], 0];
                                        }
                                        this.sessionStorageService.setMenuPermissionSession((receivedData['data']['menu_privilege']));
                                        this.sessionStorageService.setModulePermissionSession((receivedData['data']['privileges']));
                                        // this.setPermission(receivedData['data']['menu_privilege']);
                                        this.router.navigate(['/', 'dashboard']).then(() => location.reload());
                                    });
                            }
                        } else {
                            this.loading = false;
                            this.translate.get([receivedData['type'], receivedData['message']]).subscribe((response: string) => {
                                this.notificationService.basicNoty(receivedData['type'], response[receivedData['message']], response[receivedData['type']]);
                            });
                        }
                    }, (error: HttpErrorResponse | any) => console.log('Auth/login', error),
                    this.loading = false
                );
            }, 1200);
        } else {
            this.loading = false;
            this.translate.get(['ERROR', 'SESSION.FILL-FORM-PROPERLY']).subscribe((response: string) => {
                this.notificationService.basicNoty('ERROR', response['SESSION.FILL-FORM-PROPERLY'], response['ERROR']);
            });
        }
    }

    checkUserSession() {
        this.sessionStorageService.getUserSession() == null
            ? this.router.navigate([this.url])
            : this.router.navigate(['dashboard']).then((data: any) => !data ? this.checkUserSession() : true);
    }

    setUserSession(user: any, token: string): Promise<any> {
        return Promise.resolve((() => {
            this.sessionStorageService.setAccessTokenSession(token);
            this.sessionStorageService.setUserSession(user);
            this.sessionStorageService.setDateFormatSession(user.dateformat);
            this.sessionStorageService.setTimeFormatSession(user.timeformat);
        })());
    }

    setPermission(permission: Object) {
        const permissionArr = {};
        // Full Permission
        permissionArr['FULL_PERMISSION'] = permission;
        this.sessionStorageService.setMenuPermissionSession(permissionArr);
    }

    /*setPermission(permission: Object) {
        const permissionArr = {};

        // Full Permission
        permissionArr['FULL_PERMISSION'] = permission;

        // Branch Permission
        permissionArr['ADD_BRANCH'] = false;
        permissionArr['EDIT_BRANCH'] = false;
        permissionArr['DELETE_BRANCH'] = false;
        permissionArr['VIEW_BRANCH'] = false;

        $.each(permission, (id: any) => {
            switch (id) {
                case 1:
                    permissionArr['ADD_BRANCH'] = true;
                    break;
                case 2:
                    permissionArr['EDIT_BRANCH'] = true;
                    break;
                case 3:
                    permissionArr['DELETE_BRANCH'] = true;
                    break;
                case 4:
                    permissionArr['VIEW_BRANCH'] = true;
                    break;
                default:
            }
        });
        this.sessionStorageService.setPermissionSession(permissionArr);
    }*/
}
